module.exports = __webpack_public_path__ + "img/iconVr.c7100c8e.svg";